import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  carrierInformation: {
    marginRight: '15px',
  },
  listItemIcon: {
    minWidth: '0px',
    '& .MuiIconButton-colorSecondary:hover': {
      backgroundColor: 'inherit',
    },
  },
  listItem: {
    border: '1px solid #e5e5e5',

    '&$selected': {
      backgroundColor: 'white',
    },
  },
  noWrap: {
    whiteSpace: 'nowrap',
  },
  selected: {
    border: `1px solid ${theme.palette.primary.main}`,
    fontWeight: 'bold',
  },
}))
